import { AuthState } from '@okta/okta-auth-js';

import { BrokerSwap } from '../../services/backend/BrokerSwap';
import { useBaseApiClient } from '../useBaseApiClient';

export const useBrokerSwap: () => BrokerSwap<AuthState> = () => {
  return useBaseApiClient(BrokerSwap);
};
